import React from "react";
import UserProfile from "../pages/Authentication/user-profile";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "pages/Authentication/Register";
import Pages404 from "../pages/Utility/pages-404";
import Pages500 from "../pages/Utility/pages-500";
import Dashboard from "../pages/Dashboard/index";
import Joueurs from "../pages/Joueurs/index";
import PlayerInfo from "../pages/Joueurs/playerInfo/index";
import AgentPlayerInfo from "../pages/Joueurs/agentPlayerInfo";
import MesOffres from "../pages/MesOffres/index";
import AnnonceList from "pages/Annonces/annonceList/index";
import AnnonceDetaille from "pages/Annonces/annonceDetaille/index";
import AnnoncePublier from "pages/Annonces/AnnoncePublier/index";
import AgentAnnonceList from "pages/Annonces/AgenAnnonceList";
import AgentAnnounceDetails from "pages/Annonces/AgentAnnounceDetails";
import AgentAnnoncePublier from "pages/Annonces/AgentAnnoncePublier";
import ClubProfile from "pages/Club/profile/index";
import AgentProfile from "pages/Agent/Profile";
import MyAnnouncement from "pages/MyAnnouncement";
import ChatInterface from "pages/chat";
import ForgotPassword from "pages/ForgotPassword";

const RoleBased = ({ Club, Agent }) => {
  const role = localStorage.getItem("role");
  return role === "club" ? <Club /> : <Agent />;
};

const userRoutes = [
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/myOffres", component: <MesOffres /> },
  { path: "/joueurs", component: <Joueurs /> },
  {
    path: "/joueurs/playerInfo/:id",
    component: <RoleBased Club={PlayerInfo} Agent={AgentPlayerInfo} />,
  },
  {
    path: "/annonces",
    component: <RoleBased Club={AnnonceList} Agent={AgentAnnonceList} />,
  },
  { path: "/myannouncements", component: <MyAnnouncement /> },
  {
    path: "/annonces/details",
    component: <RoleBased Club={AnnonceDetaille} Agent={AgentAnnounceDetails} />,
  },
  {
    path: "/annonces/publier",
    component: <RoleBased Club={AnnoncePublier} Agent={AgentAnnoncePublier} />,
  },
  {
    path: "/profile",
    component: <RoleBased Club={ClubProfile} Agent={AgentProfile} />,
  },
  { path: "/chat/:playerId", component: <ChatInterface /> },
  { path: "/", component: <Dashboard /> },
];

const authRoutes = [
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  {path: "/forgot-password", component: <ForgotPassword /> },
  { path: "/pages-404", component: <Pages404 /> },
  { path: "/pages-500", component: <Pages500 /> },
  { path: "/register", component: <Register /> },
];

export { userRoutes, authRoutes };
